import Colors from '../../../../assets/Colors'

export const dateFilterStyles = {
  resetButtonStyle: {
    height: 'fit-content',
    marginTop: 20,
    color: Colors.napaBlueLink
  }
}
